export const state = {};
export const getters = {};
export const actions = {};
export const mutations = {};



// WEBPACK FOOTER //
// ./src/pages/home/settledDetail/store.js